import {downloadFile} from '../common/util/util';


export function setupExport(table) {
    const submit = document.getElementById('submit-export');
    if (!submit) return;
    const pathname = window.location.pathname;
    const isProject = pathname.includes('/projects/project/');
    const overview = document.getElementById('overview');
    let route = isProject ? 'export_projects' : 'export_employee';
    if (isProject && overview) {
        const match = pathname.match(/\/projects\/project\/(\d+)/);
        if (match) submit.setAttribute('id-value', match[1]);
    }
    const bindDownload = function(elem, submitElem, tabulatorTable, currentUrl, exportRoute, isExcel = false) {
        // The widget's parts are not all present on every page, and rich-text
        // fields can inject a stray #submit-export of their own. Bail instead of
        // throwing: this runs just before the select[multiple] -> SlimSelect
        // pass in projects/index.js, so an exception here leaves every
        // multi-select on the page unstyled.
        if (!elem) return;
        elem.addEventListener('click', () => {
            let ids = [];
            if (submitElem.hasAttribute('id-value')) ids = [parseInt(submitElem.getAttribute('id-value'))];
            else {
                ids = tabulatorTable.getIds();
                if (!ids.length ) ids = tabulatorTable.table.getData('active').map(row => row.id);
            }
            if (!isExcel && ids.length > 100) {
                window.alert('Too many projects to export (limit is 100), please refine the search criterias');
                return;
            }
            ids = JSON.stringify(ids);
            const params = new URLSearchParams({
                ids: ids,
            });
            if (isExcel) params.append('to_excel', true);
            else params.append('template', submitElem.getAttribute('template'));
            if (currentUrl.includes('/employee/')) {
                const parts = currentUrl.split('/').filter(part => part);
                params.append('id_emp', parts[parts.length - 1]);
            }
            downloadFile(`${appPrefix}/${exportRoute}/?${params}`);
        });
    };
    bindDownload(submit, submit, table, pathname, route, false);
    bindDownload(document.getElementById('export-excel'), submit, table, pathname, route, true);
    let selectedTemplate = document.getElementById('selected-template');
    if (!selectedTemplate) return;
    selectedTemplate = selectedTemplate.children[0]
    const handleDelete = function(e) {
        const target = e.target;
        const form = new URLSearchParams({
            file: e.target.getAttribute('template')
        });
        if (isProject) form.append('directory', 'projects');
        else form.append('directory', 'employee');
        fetch(`${appPrefix}/delete_template/?${form}`).then(res => {
            target.parentNode.remove();
        });
    }
    const handleSelectTemplate = function(e) {
        const elem = e.target;
        // replace text
        selectedTemplate.innerHTML = elem.innerHTML;
        // replace pointed URL
        let baseUrl = selectedTemplate.getAttribute('href').split('/');
        baseUrl.pop()
        const newUrl = baseUrl.join('/') + '/' + elem.innerHTML;
        selectedTemplate.setAttribute('href', newUrl);
        submit.setAttribute('template', elem.innerHTML);
    };
    Array.from(document.getElementsByClassName('name-template')).forEach(elem => {
        elem.addEventListener('click', handleSelectTemplate);
    });
    Array.from(document.getElementsByClassName('delete-template')).forEach(elem => {
        elem.addEventListener('click', handleDelete);
    });
    const templatesList = document.getElementById('templates');
    const inputTemplate = document.getElementById('template-import');
    const directory = isProject ? 'projects' : 'employee';
    inputTemplate.onchange = function(e) {
        const file = inputTemplate.files[0];
        const form = new FormData();
        form.append('directory', directory);
        form.append('file', file);
        fetch(`${appPrefix}/add_template/`, {
            method: 'post',
            body: form,
        })
        .then(res=>res.json())
        .then(res => {
            const div = document.createElement('div');
            div.classList.add('choice');
            const span = document.createElement('span');
            span.classList.add('name-template');
            span.addEventListener('click', handleSelectTemplate);
            const loc = decodeURI(res.location);
            const prefix = `/media/projects/templates/${directory}/`;
            span.innerHTML = loc.substring(prefix.length);
            div.append(span);
            const a = document.createElement('a');
            a.innerHTML = "View";
            a.setAttribute('href', res.location);
            div.append(a);
            const i = document.createElement('i');
            i.innerHTML = "Delete";
            i.setAttribute('template', span.innerHTML);
            i.classList.add('delete-template');
            i.addEventListener('click', handleDelete);
            div.append(i);
            templatesList.append(div);
        });
    }
}

export function updateSelected(rows) {
    const nb = document.getElementById('selected-projects');
    if (nb) nb.innerHTML = rows.length;
}

export class SelectionManager {
    constructor(table) {
        this.defaultName ='Selection';
        this.table = table;
        this.mapping = {}; // id => projectIds
        this.btnAdd = document.getElementById('add-save');
        this.btnSave = document.getElementById('save-as');
        this.btnDelete = document.getElementById('delete-selection');
        this.selectedLabel = document.getElementById('selected-label');
        this.setupSelectionSelect();
        this.setupSelectionName();
        this.selected = document.getElementById('selected-selection');
        this.selected.style.display = 'none';
        this.btnSave.style.display = 'none';
        this.btnDelete.style.display = 'none';
        if (this.selectSelections.options.length == 1) {
            this.selectSelections.style.display = 'none';
        }
        this.parent = this.btnAdd.parentElement;
        this.btnAdd.addEventListener('click', () => {
            const params = new URLSearchParams({
                name: this.defaultName,
                proj_ids: JSON.stringify(this.getProjectIds()),
            });
            fetch(`${appPrefix}/add_selection/?${params}`)
            .then(res =>  res.json())
            .then(data => {
                this.changeSelectedSelection(data.id, data.name);
                const newOption = document.createElement('option');
                newOption.setAttribute('value', data.id);
                newOption.innerHTML = data.name;
                this.selectSelections.appendChild(newOption);
                this.selectSelections.selectedIndex = this.selectSelections.options.length - 1;
                this.setProjectIds();
            });
        });
        this.btnSave.addEventListener('click', () => {
            if (!this.selected) return;
            const selectedId = this.selected.getAttribute('selected-id');
            this.setProjectIds();
            this.updateSelectionRequest({'select_id': selectedId, 'proj_ids': JSON.stringify(this.getProjectIds())});
        });
        this.btnDelete.addEventListener('click', () => {
            if (!this.selected) return;
            const selectedId = this.selected.getAttribute('selected-id');
            this.deleteSelectionRequest(selectedId);
            const nbOpt = this.selectSelections.options.length;
            this.selectSelections.options[this.selectSelections.selectedIndex].remove();
            this.selectSelections.selectedIndex = nbOpt - 2;
            this.handleSelect();
        });
    }

    setupSelectionSelect() {
        this.selectSelections = document.getElementById('existing-selections');
        for (const opt of this.selectSelections.options) {
            const ids = opt.getAttribute('ids');
            const selectId = opt.getAttribute('value');
            this.mapping[selectId] = ids ? JSON.parse(ids) : [];
        }
        this.selectSelections.addEventListener('change', () => { this.handleSelect() ;});
    }

    handleSelect() {
        const text = this.selectSelections.options[this.selectSelections.selectedIndex].text;
        this.changeSelectedSelection(this.selectSelections.value, text);
        this.selectFromIds();
    }

    setupSelectionName() {
        this.selected = document.getElementById('selected-selection');
        let timeoutId = null;
        this.selected.addEventListener('input', () => {
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                const selectedId = this.selected.getAttribute('selected-id');
                const name = this.selected.value;
                this.updateSelectionRequest({'select_id': selectedId, 'name': name}, this.changeOptionName);
            }, 500);
        });
    }

    changeOptionName() {
        const id = this.selected.getAttribute('selected-id');
        this.selectedLabel.innerHTML = this.selected.value;
        for (const opt of this.selectSelections.options) {
            if (opt.value == id) {opt.innerHTML = this.selected.value; return;}
        }
    }

    changeSelectedSelection(id, name) {
        let display = 'inline-block';
        if (id.length == 0) display = 'none';
        this.selected.style.display = display;
        this.btnSave.style.display = display;
        this.btnDelete.style.display = display;
        this.selected.value = name;
        this.selected.setAttribute('selected-id', id);
        this.selectedLabel.innerHTML = name;
    }

    setProjectIds() {
        const selectId = this.selected.getAttribute('selected-id');
        this.mapping[selectId] = this.getProjectIds();
    }

    getProjectIds() { return this.table.table.getSelectedRows().map(row => row.getData().id); }

    selectFromIds() {
        const ids = this.mapping[this.selected.getAttribute('selected-id')];
        this.table.table.getRows().forEach(row => {
            if(ids.includes(row.getData().id)) row.select();
            else row.deselect();
        });
        let checked = 'checked';
        if (!ids.length) checked = null;
        if (this.table.onlySelectedCheckbox) {
            this.table.onlySelectedCheckbox.checked = checked;
        }
        this.table.filterSelectedIds();
    }

    updateSelectionRequest(args, cb = null) {
        const params = new URLSearchParams({...args});
        fetch(`${appPrefix}/update_selection/?${params}`).then(res =>  {
            if (cb) cb.call(this);
        });
    }
    deleteSelectionRequest(id, cb) {
        fetch(`${appPrefix}/delete_selection/${id}`).then(res =>  {
            if (cb) cb.call(this);
        });
    }

}
